// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__bRmkH","modalForm":"UpgradeEpcsModal_modalForm__345ye","modalFooter":"UpgradeEpcsModal_modalFooter__3_m2W"};